import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });

    // You can also log to an error reporting service here
    // Example: logErrorToService(error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
          <Container>
            <div className="text-center">
              <div className="mb-4">
                <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '4rem' }}></i>
              </div>
              <h1 className="mb-3">Oups ! Une erreur s'est produite</h1>
              <Alert variant="danger" className="text-start mx-auto" style={{ maxWidth: '600px' }}>
                <Alert.Heading>Détails de l'erreur</Alert.Heading>
                <p className="mb-0">
                  <strong>Message :</strong> {this.state.error && this.state.error.toString()}
                </p>
                {process.env.NODE_ENV === 'development' && this.state.errorInfo && (
                  <details className="mt-3" style={{ whiteSpace: 'pre-wrap' }}>
                    <summary>Stack trace (développement uniquement)</summary>
                    {this.state.errorInfo.componentStack}
                  </details>
                )}
              </Alert>
              <div className="mt-4">
                <Button variant="primary" size="lg" onClick={this.handleReload} className="me-3">
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  Recharger la page
                </Button>
                <Button variant="outline-secondary" size="lg" href="/">
                  <i className="bi bi-house me-2"></i>
                  Retour à l'accueil
                </Button>
              </div>
              <div className="mt-4">
                <p className="text-muted">
                  Si le problème persiste, veuillez contacter le support :{' '}
                  <a href="mailto:support@leagora.fr">support@leagora.fr</a>
                </p>
              </div>
            </div>
          </Container>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
